export const REST_ENDPOINT = process.env.VUE_APP_REST_ENDPOINT